export const APP_SETTINGS_PATHS = {
  settings: 'settings',
};
